import React, { useEffect, useState } from "react";
import { ArrowRightCircleIcon } from "../../assets/icons/ArrowRightCircleIcon";
import "./index.scss"; // Assurez-vous que le chemin est correct
import blog from "../../assets/images/blog.png";
import BlogService from "../../services/blog/blog.service";
import { showErrorToaster } from "../../components/toaster/error";
import { useNavigate } from "react-router-dom";
const blogService = new BlogService(); // Remplacez par le bon chemin de l'image
export const BlogList = () => {
  const [blogs, setblog] = useState([]);
  const navigate = useNavigate();
  const loadformation = async () => {
    try {
      const res = await blogService.getAllBlogActive();
      setblog(res?.data || []);
    } catch (error) {
      showErrorToaster("Erreur lors du chargement des actualites.");
    }
  };
  useEffect(() => {
    loadformation();
  }, []);
  console.log(blogs);
  const truncateText = (text, maxLength) => {
    return text?.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };
  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  function getImageURL(id) {
    return `${apiUrl}/blogs/${id}/image`;
  }
  return (
    <div className="blogList pt-5">
      <div className="row ms-0 justify-content-center  gx-0 w-100 align-items-center mb-5 mt-5">
        {blogs?.map((item, index) => (
          <div className="col-12 col-md-4 mx-auto ">
            {" "}
            <div
              className="blog-card"
              onClick={() => {
                navigate(`/blog/${item?._id}`);
                window.scroll(0, 0);
              }}>
              <img
                src={getImageURL(item?._id)} // remplace par le bon chemin
                alt="isolation"
                className="blog-card-img"
              />
              <div className="blog-card-body ">
                <div className="blog-card-title-row mt-5">
                  <h5 className="blog-card-title ">{item?.title}</h5>
                  <div
                    onClick={() => {
                      navigate(`/blog/${item?._id}`);
                      window.scroll(0, 0);
                    }}>
                    {" "}
                    <ArrowRightCircleIcon />
                  </div>
                </div>
                <p className="blog-card-description">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: truncateText(item?.description, 120),
                    }}
                  />
                </p>
                <p className="blog-card-date">
                  {new Date(item?.date).toLocaleDateString("fr-FR")}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
